module.exports = __webpack_public_path__ + "img/c1.3bb55749.png";